<div style="display: flex; align-items: center; gap: 5px;">
  <div *ngIf="isMultipleCustomerAvailable" class="custom-select-container responsive-field text-algin-right"
    style="font-size: 14px;">
    <div class="custom-select" [class.open]="isCustomerDropdownOpen"
      [class.with-help]="isContactAvailable || menuPages?.indexOf('HELP_PAGE') > -1 || menuPages?.includes('HELP_DOCUMENT')"
      [class.without-help]="!(isContactAvailable || menuPages?.indexOf('HELP_PAGE') > -1 || menuPages?.includes('HELP_DOCUMENT'))"
      (click)="toggleCustomerDropdown()">
      <div class="select-trigger" [ngClass]="isCustomerDropdownThemeAvailable ? 'text-white' : 'text-black'">
        <span>{{getSelectedCustomerName()}}</span>
        <div class="custom-arrow"></div>
      </div>
      <div class="custom-options" *ngIf="isCustomerDropdownOpen">
        <div class="search-option">
          <div class="search-container">
            <span class="search-icon"></span>
            <input type="text" [(ngModel)]="searchTxt" placeholder="Search" (ngModelChange)="modelChangeFn($event)"
              (click)="$event.stopPropagation()" class="search-input">
          </div>
        </div>
        <div class="option" *ngIf="searchTxt && customerNewList.length == 0">
          <span>Customer Not Found</span>
        </div>
        <div class="option" *ngFor="let customer of customerList | search : searchTxt"
          (click)="selectCustomer(customer.customerCode, $event)"
          [class.selected]="selectedCustomer === customer.customerCode">
          {{customer.customerName}}
        </div>
      </div>
    </div>
  </div>
  <div class="set-padding" style="padding: 0px 5px; display: flex; align-items: center; gap: 5px;">
    <div *ngIf="isMultiLangAvailable" class="custom-select-container responsive-width"
      style="font-size: 14px; flex-shrink: 0; width: auto;">
      <div class="custom-select" [class.open]="isLanguageDropdownOpen" (click)="toggleLanguageDropdown()">
        <div class="select-trigger">
          <img src="../assets/images/{{selectedLangString.flag}}" class="img-dimension" />
          <span style="padding: 0 8px;">{{selectedLangString.label}}</span>
          <div class="custom-arrow"></div>
        </div>
        <div class="custom-options" *ngIf="isLanguageDropdownOpen">
          <div class="option language-option" *ngFor="let lang of languageList" (click)="selectLanguage(lang)"
            [class.selected]="selectedLang === lang.key">
            <img src="../assets/images/{{lang.flag}}" class="img-dimension" />
            <span style="padding: 0 8px;">{{lang.label}}</span>
            <span class="check-icon" *ngIf="selectedLang === lang.key">✓</span>
          </div>
        </div>
      </div>
    </div>
    <div class="help-menu-pane"
      *ngIf="isContactAvailable || menuPages?.indexOf('HELP_PAGE') > -1 || menuPages?.includes('HELP_DOCUMENT')">
      <button [ngClass]="{'help-dropdown': !isMultipleCustomerAvailable}" class="help-button"
        (click)="toggleHelpMenu()">Help <div class="custom-arrow"></div></button>
      <div class="help-menu-list" *ngIf="isHelpMenuOpen">
        <button class="menu-item"
          *ngIf="isContactAvailable && !menuPages.includes('HELP_PAGE') && !menuPages.includes('HELP_DOCUMENT')"
          (click)="redirectToContact(); closeHelpMenu()"
          [ngStyle]="{'font-weight':isActiveProject? 'bold' : 'normal' }">Contact Us</button>
        <button class="menu-item" routerLink="/help-desk" *ngIf="menuPages.includes('HELP_PAGE')"
          (click)="closeHelpMenu()">Contact Help Desk</button>
        <button class="menu-item" *ngIf="!menuPages.includes('HELP_DOCUMENT')"
          (click)="downloadFile(); closeHelpMenu()">Training Document</button>
        <button class="menu-item" *ngIf="menuPages.includes('HELP_DOCUMENT')"
          (click)="downloadFile(); closeHelpMenu()">Document</button>
      </div>
    </div>
  </div>
</div>